<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>

      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="
            row.userStatus === 'N'
              ? 'warning'
              : row.userStatus === 'S'
              ? 'danger'
              : row.userStatus === 'Y'
              ? 'success'
              : ''
          "
        >
          {{ row.v_userStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_view') || '查看'"
            placement="top"
          >
            <i
              class="el-icon-view tool-btn"
              @click="
                openEditPage({
                  pageType: 'detail',
                  params: { userCode: row.userCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_edit') || '编辑'"
            placement="top"
            v-if="allow('M')"
            v-show="row.userStatus === 'Y'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                openEditPage({
                  pageType: 'edit',
                  params: { userCode: row.userCode },
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
            v-if="allow('D')"
            v-show="row.userStatus === 'Y'"
          >
            <i class="el-icon-delete tool-btn" @click="del(row.userCode)"></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('form_label_reset_password') || '重置密码'"
            placement="top"
            v-show="row.userStatus === 'Y'"
            v-if="allow('R')"
          >
            <i
              class="el-icon-refresh tool-btn"
              @click="restPassword(row.userCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('form_label_deactivate') || '停用'"
            placement="top"
            v-show="row.userStatus === 'Y'"
            v-if="allow('S')"
          >
            <i
              class="el-icon-video-pause tool-btn"
              @click="deactivate(row.userCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$l('form_label_enable') || '启用'"
            placement="top"
            v-show="row.userStatus === 'N' || row.userStatus === 'S'"
            v-if="allow('N')"
          >
            <i
              class="el-icon-video-play tool-btn"
              @click="enable(row.userCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">{{ $l('INDEX.table_label_no_data') || '暂无数据！' }}</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    tablePage: {
      default: null,
      type: Object,
    },
    loading: {
      default: false,
    },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          fixed: 'left',
          type: 'seq',
        },
        {
          field: 'col-opt',
          title: this.$l('INDEX.table_label_operation') || '操作',
          headerAlign: 'center',
          align: 'left',
          fixed: 'left',
          width: 170,
          slots: {
            default: 'opt',
          },
        },
        {
          title: this.$l('table_label_user_account') || '用户账号',
          field: 'userNo',
          minWidth: 150,
          align: 'left',
          headerAlign: 'center',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_chinese_name') || '中文姓名',
          field: 'userName',
          width: 150,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_english_name') || '英文姓名',
          field: 'userNameEn',
          width: 150,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_english_name_abbreviation') || '英文名称缩写',
          field: 'userShortNameEn',
          width: 150,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_phone_number') || '手机号码',
          field: 'mobileNumber',
          width: 150,
          align: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('table_label_mailing_address') || '邮件地址',
          field: 'emailAddress',
          width: 220,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('table_label_fixed_telephone') || '固定电话',
          field: 'fixedTelephone',
          width: 160,
          align: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('table_label_position') || '职位',
          field: 'userPost',
          width: 120,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_organization') || '所属机构',
          field: 'orgName',
          width: 200,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_department') || '所属部门',
          field: 'depName',
          width: 150,
          align: 'left',
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_business') || '业务角色',
          field: 'v_userJobType',
          width: 150,
          align: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_cg_cr_permission_range') || '对应客户权限范围',
          field: 'v_userCustRange',
          width: 150,
          align: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
          sortable: true,
          sortType: 'string',
        },
        {
          title: this.$l('table_label_state') ||'状态',
          width: 80,
          align: 'center',
          slots: { default: 'status' },
        },
        {
          field: 'createByName',
          title: this.$l('table_label_creator') ||'创建人',
          width: 100,
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('table_label_creation_time') ||'创建时间',
          field: 'createDate',
          width: 170,
          align: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          field: 'modifyByName',
          title: this.$l('INDEX.table_label_modified_by') ||'修改人',
          width: 100,
          headerAlign: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
        {
          title: this.$l('INDEX.table_label_modification_date') ||'修改时间',
          field: 'modifyDate',
          width: 170,
          align: 'center',
          showHeaderOverflow: 'title',
          showOverflow: 'ellipsis',
        },
      ],
    }
  },
  methods: {
    del(userCode) {
      this.$confirm(this.$l('INDEX.form_label_delete_user') || '确认要删除该用户吗？', this.$l('INDEX.label_completeDesc') || '确认信息', {
        confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          userCode,
          userStatus: 'N',
        }
        this.$api.sysUserDelApi(params).then((res) => {
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_delete_ok') || '删除成功！',
              type: 'success',
            })
            this.$emit('reload')
          }
        })
      })
    },
    deactivate(userCode) {
      this.$confirm(this.$l('INDEX.form_label_deactivate_user') || '确认要停用该用户吗？', this.$l('INDEX.label_completeDesc') || '确认信息', {
        confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          userCode,
          userStatus: 'S',
        }
        this.$api.sysUserDeactivateApi(params).then((res) => {
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.form_label_deactivation_succeeded') || '停用成功！',
              type: 'success',
            })
            this.$emit('reload')
          }
        })
      })
    },
    enable(userCode) {
      this.$confirm(this.$l('INDEX.form_label_enable_user') || '确认要启用该用户吗？', this.$l('INDEX.label_completeDesc') || '确认信息', {
        confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        const params = {
          userCode,
          userStatus: 'Y',
        }
        this.$api.sysUserEnableApi(params).then((res) => {
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.form_label_enabled_successfully') || '启用成功！',
              type: 'success',
            })
            this.$emit('reload')
          }
        })
      })
    },
    restPassword(userCode) {
      this.$confirm(this.$l('INDEX.form_label_reset_users_password') || '确认要重置该用户密码吗？', this.$l('INDEX.label_completeDesc') || '确认信息', {
        confirmButtonText: this.$l('INDEX.product_dialog_btn_confirm') || '确定',
        cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
        type: 'warning',
      }).then(() => {
        this.$api.sysUserResetPasswordApi({ userCode }).then((res) => {
          const { status } = res
          if (status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.form_label_reset_succeeded') || '重置成功！',
              type: 'success',
            })
            this.$emit('reload')
          }
        })
      })
    },
    openEditPage({ pageType, params }) {
      this.$router.push({
        name: 'system-sysuser-detail',
        params: { ...params, pageType },
      })
    },
  },
}
</script>
